import { Inject, Injectable } from '@angular/core';
import { SW_CONFIG } from './injection-tokens';
import { SwConfig } from './types';
import { UpdatesHandlerService } from './updates-handler';

@Injectable()
export class UpdatesListenerService {
  constructor(@Inject(SW_CONFIG) private swConfig: SwConfig, private updatesHandler: UpdatesHandlerService) {}

  subscribeToUpdates(): void {
    this.mainAsync();
  }

  private async mainAsync(): Promise<void> {
    if (this.swConfig.isEnabled) {
      await this.updatesHandler.initAsync(this.swConfig);
      this.handleActivatedUpdate();
    }
  }

  private handleActivatedUpdate(): void {
    this.updatesHandler.updateActivated$.subscribe(() => {
      window.location.reload();
    });
  }
}
